import React from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";
import GridWithOffset from "./GridWithOffset";
import Contents from "./Contents";

const WithGrid = ({
    isHeading1,
    isHeading2,
    isHeading4,
    text,
    subtext,
    button
}) => {
    return (
        <GridWithOffset>
            <Grid item sm={12} md={12} lg={12}>
                <Contents
                    isHeading1={isHeading1}
                    isHeading2={isHeading2}
                    isHeading4={isHeading4}
                    text={text}
                    subtext={subtext}
                    button={button}
                />
            </Grid>
        </GridWithOffset>
    );
};

WithGrid.propTypes = {
    isHeading1: PropTypes.bool,
    isHeading2: PropTypes.bool,
    isHeading4: PropTypes.bool,
    text: PropTypes.string.isRequired,
    subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    button: PropTypes.object
};

export default WithGrid;
